import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import {HoraSeleccionar} from './HoraSeleccionar';

import FormularioPago from '../FormularioPago/FormularioPago';
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import getPublishableKey from '../../stripe/publishableKey';

const stripe_publishable_key = getPublishableKey();
const stripePromise = loadStripe(stripe_publishable_key);

export const ModalAnadirServicioNormal = (props) => {
	const {
		ModalAnadirServicio,
		Servicio,
		activeStep,
		MyDate,
		setMyDate,
		addMonths,
		generarListaDias,
		ListaHoras,
		EstadoConsulta,
		ModalSeleccionHora,
		setModalSeleccionHora,
		ModalSeleccionPaciente,
		setModalSeleccionPaciente,
		setActiveStep,
		ExampleCustomInput,
		changeHora,
		ListaPacientes,
		Paciente,
		seleccionarPaciente,
		modHoraModal,
		steps,
		isStepSkipped,
		anadiServicioLista,
		setModalAnadirServicio,
		getHoras,
		enviarYMostrarResultado,
		hayHora,
		empresa,
		createPayment,
		stripeMessage,
		get_clientSecret,
		clientSecret,
		factura,
	} = props;
	const options = {
		clientSecret,
		paymentMethodCreation: 'manual',
	};
	// if (activeStep === 4) {
	// 	document.getElementById('disable-button').style.display = 'none';
	// } else {
	// 	if (activeStep > 0) {
	// 		document.getElementById('disable-button').style.display = 'grid';
	// 	}
	// }
	return (
		<Modal
			centered={true}
			isOpen={ModalAnadirServicio}
		>
			<ModalHeader>
				<div className='titulo-modal'>
					<>{Servicio.servicio_id.nombre}</>
					{activeStep === 0 ? (
						<>Selecione el dia</>
					) : activeStep === 1 ? (
						<>Seleccione la hora</>
					) : activeStep === 2 ? (
						<>Seleccione a su paciente</>
					) : activeStep === 3 ? (
						<>Confirmación</>
					) : activeStep === 4 ? (
						<>Pago</>
					) : EstadoConsulta ? (
						<>Servicio contratado correctamente</>
					) : (
						<>Algo salió mal</>
					)}
				</div>
				<div>x</div>
			</ModalHeader>
			<ModalBody>
				<>
					<div className='calendario-modal-perfil-agencia'>
						{activeStep === 0 ? (
							<div className=' centrador'>
								<DatePicker
									selected={MyDate}
									onChange={(date) => setMyDate(date)}
									locale='es'
									minDate={new Date()}
									maxDate={addMonths(new Date(), 12)}
									excludeDates={generarListaDias()}
									//showMonthYearDropdown
									//showTimeSelect
									//timeIntervals={15}
									inline={true}
									className='calendario-perfil-empresa'
									customInput={<ExampleCustomInput />}
									closeOnScroll={true}
									hidePopper={false}
									//timeClassName={handleColor}
								/>
							</div>
						) : activeStep === 1 ? (
							<div className='centrador'>
								<div className='lista-horas-perfil-empresa'>
									{ListaHoras.map((hora) => {
										return (
											<HoraSeleccionar
												hora={hora}
												changeHora={changeHora}
												fechaSeleccionada={MyDate}
											/>
										);
									})}
								</div>
							</div>
						) : activeStep === 2 ? (
							<div className='listaPacientesModal'>
								{ListaPacientes.map((paciente) => {
									return (
										<div
											className={
												paciente.id === Paciente.id
													? 'seleccionPacienteModal-Active'
													: 'seleccionPacienteModal'
											}
											onClick={() => seleccionarPaciente(paciente.id)}
										>
											<div className='fotoSeleccionPacienteModal centrador'>
												<img src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images' />
											</div>
											<div className='nombreSeleccionPacienteModal centrador'>
												<div>
													{paciente.nombrePaciente}{' '}
													{paciente.apellidosPaciente}
												</div>
												<div>{paciente.direccionPaciente}</div>
											</div>
										</div>
									);
								})}
							</div>
						) : activeStep === 3 ? (
							<div class='pedido-detalle'>
								<div className='info'>Detalles de la contratación</div>
								<div className='separador' />
								<div className='info detalles'>Detalles del paciente</div>
								<div className='info-pedido'>
									<div class='horas-disponibles '>
										<div class='mod-hora-modal'>
											<b>Dia: </b>
											{modHoraModal()}
										</div>
										{ListaHoras.map((hora) => {
											if (hora.estado) {
												return (
													<div className='mod-hora-modal'>
														<b>Hora: </b>
														{hora.hora}
													</div>
												);
											}
										})}
										<div className='mod-hora-modal'>
											<b>Precio: </b>
											{Servicio.precioMin} €
										</div>
										<div className='mod-hora-modal'>
											<b>Duración: </b>
											{Servicio.horasMin} min
										</div>
									</div>
									<div class='paciente-detalles'>
										<div class='mod-hora-modal'>
											<b>Nombre: </b>
											{Paciente.nombrePaciente}
										</div>
										<div class='mod-hora-modal'>
											<b>Apellidos: </b>
											{Paciente.apellidosPaciente}
										</div>
										<div class='mod-hora-modal'>
											<b>Dirección: </b>
											{Paciente.direccionPaciente}
										</div>
									</div>
								</div>
							</div>
						) : activeStep === 4 ? (
							clientSecret ? (
								<div>
									<Elements
										options={options}
										stripe={stripePromise}
									>
										<FormularioPago
											factura={factura}
											stripeMessage={stripeMessage}
											createPayment={createPayment}
											enviarYMostrarResultado={enviarYMostrarResultado}
											setActiveStep={setActiveStep}
											activeStep={activeStep}
										/>
									</Elements>
								</div>
							) : (
								<div className='descripcion-servicio descripcion-modal'>
									Cargando...
								</div>
							)
						) : EstadoConsulta ? (
							<div className='descripcion-servicio descripcion-modal'>
								Su compra se ha procesado correctamente. Hemos enviado un correo
								electrónico a su dirección de correo electrónico con los detalles de
								su compra. ¡Gracias por confiar en Cuidatia!
							</div>
						) : (
							<div className='descripcion-servicio descripcion-modal'>
								¡Vaya! Algo salió mal y no se pudo procesar su solicitud. Por favor,
								inténtelo de nuevo más tarde o póngase en contacto con nuestro
								equipo de soporte si el problema persiste. ¡Gracias por su paciencia
								y comprensión!
							</div>
						)}
					</div>
					<div className='steps-modal-pefil-empresa'>
						<Box sx={{width: '100%'}}>
							<Stepper activeStep={activeStep}>
								{steps.map((label, index) => {
									const stepProps = {};
									const labelProps = {};
									if (isStepSkipped(index)) {
										stepProps.completed = false;
									}
									if (index < steps.length - 1) {
										return (
											<Step
												key={label}
												{...stepProps}
												className='step-perfil-empresa'
											>
												<StepLabel {...labelProps}>{label}</StepLabel>
											</Step>
										);
									}
								})}
							</Stepper>
						</Box>
					</div>
					<Modal
						centered={true}
						isOpen={ModalSeleccionHora}
					>
						<ModalHeader>
							<div className='titulo-modal'>Hora de elegir tu hora ideal</div>
						</ModalHeader>
						<ModalBody>
							<div className='descripcion-servicio descripcion-modal'>
								¡Vamos por partes! Antes de continuar con la contratación de
								nuestros servicios, necesitamos que elijas la hora que mejor te
								acomode. ¡No te preocupes! Tenemos una amplia variedad de horarios
								disponibles para que elijas el que más se adapte a tus necesidades.
								Una vez que hayas seleccionado la hora perfecta, podrás seguir
								adelante con el proceso de contratación. Si tienes alguna pregunta o
								necesitas ayuda para elegir la hora ideal, solo háznoslo saber.
								¡Estamos aquí para ayudarte en todo momento!
							</div>
						</ModalBody>
						<ModalFooter>
							<div className='centrador'>
								<div
									className='button'
									onClick={() => setModalSeleccionHora(false)}
								>
									<b>Aceptar</b>
								</div>
							</div>
						</ModalFooter>
					</Modal>
					{/********************************************************************************************************************** */}
					<Modal
						centered={true}
						isOpen={ModalSeleccionPaciente}
					>
						<ModalHeader>
							<div className='titulo-modal'>¡Elige a tu héroe (paciente)!</div>
						</ModalHeader>
						<ModalBody>
							<div className='descripcion-servicio descripcion-modal'>
								¡Hola! Para poder contratar nuestros servicios, necesitas elegir a
								uno de tus pacientes. Ellos serán los héroes que recibirán los
								servicios que contrates. Si aún no tienes ningún paciente
								registrado, ¡no te preocupes! Puedes agregar uno fácilmente antes de
								continuar con el proceso de contratación. Si tienes alguna duda o
								necesitas ayuda para elegir al paciente adecuado, no dudes en
								contactarnos. ¡Estamos aquí para ayudarte!
							</div>
						</ModalBody>
						<ModalFooter>
							<div className='centrador'>
								<div
									className='button'
									onClick={() => setModalSeleccionPaciente(false)}
								>
									<b>Aceptar</b>
								</div>
							</div>
						</ModalFooter>
					</Modal>
				</>
			</ModalBody>
			<ModalFooter>
				<div className='centrador-Botones-botones-perfil-empresa'>
					<div
						className='buttonB'
						onClick={() => {
							anadiServicioLista();
							if (activeStep > 0) {
								setActiveStep(activeStep - 1);
							} else {
								setModalAnadirServicio(false);
							}
						}}
					>
						{activeStep === 0 ? <b>Cancelar</b> : <b>Atras</b>}
					</div>
					<div
						className='button'
						onClick={() => {
							anadiServicioLista();
							if (activeStep < steps.length) {
								switch (activeStep) {
									case 0:
										getHoras();
										setActiveStep(activeStep + 1);
										break;
									case 1:
										if (hayHora()) {
											setActiveStep(activeStep + 1);
										} else {
											setModalSeleccionHora(true);
										}
										break;
									case 2:
										if (!Paciente || Object.keys(Paciente).length === 0) {
											setModalSeleccionPaciente(true);
										} else {
											setActiveStep(activeStep + 1);
										}
										break;
									case 3:
										get_clientSecret();
										setActiveStep(activeStep + 1);
										break;
									case 4:
										//enviarYMostrarResultado();
										setActiveStep(activeStep + 1);
										break;
									default:
										setModalAnadirServicio(false);
										setActiveStep(activeStep - 4);
										window.location.reload()
										break;
								}
							} else {
								setModalAnadirServicio(false);
							}
						}}
					>
						<b>{activeStep === 4 ? 'Finalizar' : 'Siguiente'}</b>
					</div>
				</div>
			</ModalFooter>
		</Modal>
	);
};
